import { useEffect, useState } from "react";
import { Palmtree, Rocket } from "lucide-react";
import api from "@/lib/api";

const day = (d) => new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short" });

export default function HolidayProgress({ childId }) {
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/children/${childId}/holiday/progress`).then(({ data }) => setP(data)).catch(() => {}); }, [childId]);
  if (!p || (!p.holiday_until && !p.rounds)) return null;
  const upcoming = p.holiday_from && new Date(p.holiday_from) > new Date();
  return (
    <div className="mt-3 rounded-2xl bg-orange-50 border-2 border-orange-300 p-3 text-sm" data-testid={`holiday-progress-${childId}`}>
      <p className="font-bold flex items-center gap-1.5"><Palmtree size={15} className="text-orange-500" /> Holiday Pack
        {p.holiday_until && <span className="ml-auto text-xs font-normal text-slate-500">{upcoming ? `booked · opens ${day(p.holiday_from)}` : `until ${day(p.holiday_until)}`}</span>}</p>
      {p.rounds === 0 ? <p className="text-slate-500 mt-1" data-testid={`holiday-progress-empty-${childId}`}>{upcoming ? "Spot booked! The pack opens on 15 November." : "No holiday round played yet."}</p> : (
        <>
          <div className="grid grid-cols-4 gap-1 mt-2 text-center text-xs">
            <Box label="Rounds" value={p.rounds} id="rounds" childId={childId} />
            <Box label="Best" value={`${p.best}%`} id="best" childId={childId} />
            <Box label="Last" value={`${p.last}%`} id="last" childId={childId} />
            <Box label="Pack" value={p.pack_total ? `${p.done}/${p.pack_total}` : "-"} id="pack" childId={childId} />
          </div>
          <p className="text-xs mt-2 flex items-center gap-1" data-testid={`holiday-next-year-${childId}`}><Rocket size={12} className="text-violet-600" /> Next-year questions right: <b>{p.next_ok}/{p.next_total}</b>{p.finished && <span className="ml-auto font-bold text-green-700">Pack finished!</span>}</p>
          <table className="w-full mt-2 text-xs">
            <thead><tr className="text-slate-500 text-left"><th className="font-medium pr-2">Subject</th><th className="font-medium pr-2">Answered</th><th className="font-medium pr-2">Correct</th><th className="font-medium">Last round</th></tr></thead>
            <tbody>
              {p.subjects.map((s) => (
                <tr key={s.subject} data-testid={`holiday-progress-row-${childId}-${s.subject}`}>
                  <td className="font-semibold py-0.5 pr-2">{s.subject}</td><td className="pr-2">{s.answered}</td><td className="pr-2">{s.percent}%</td><td>{s.last}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}

function Box({ label, value, id, childId }) {
  return (
    <div className="rounded-xl bg-white border border-orange-200 py-1" data-testid={`holiday-${id}-${childId}`}>
      <p className="font-bold text-sm">{value}</p>
      <p className="text-slate-500">{label}</p>
    </div>
  );
}
